import {
  GET_MRD_CONTACTS_REQUEST,
  GET_MRD_CONTACTS_SUCCESS,
  GET_MRD_CONTACTS_FAILURE,
  ASSOCIATE_CONTACTS_REQUEST,
  ASSOCIATE_CONTACTS_SUCCESS,
  ASSOCIATE_CONTACTS_FAILURE,
} from './types/ContactManagementActionTypes';

export function getMrdContactsRequestActionCreator(action) {
  return {
    type: GET_MRD_CONTACTS_REQUEST,
    action,
  };
}

export function getMrdContactsSuccessActionCreator(data) {
  return {
    type: GET_MRD_CONTACTS_SUCCESS,
    payload: data,
  };
}

export function getMrdContactsFailureActionCreator(error) {
  return {
    type: GET_MRD_CONTACTS_FAILURE,
    payload: error,
    error: true,
  };
}

export function associateMrdContactsRequestActionCreator(payload) {
  return {
    type: ASSOCIATE_CONTACTS_REQUEST,
    payload,
  };
}

export function associateMrdContactsSuccessActionCreator(data) {
  return {
    type: ASSOCIATE_CONTACTS_SUCCESS,
    payload: data,
  };
}

export function associateMrdContactsFailureActionCreator(error) {
  return {
    type: ASSOCIATE_CONTACTS_FAILURE,
    payload: error,
    error: true,
  };
}
